import React from "react";

const Errror = () => {
  return <div>Error</div>;
};

export default Errror;
